const text = (value) => value == null ? "" : Array.isArray(value) ? value.map(text).join(", ") : String(value);
const BASE_HEADERS = ["First name", "Last name", "Full name", "Company", "Position", "Email", "Attendee type", "QR code", "Eventbrite attendee ID"];

export const toAttendeeSpreadsheet = (attendees) => {
  const active = [...new Map(attendees.filter((attendee) => attendee.id && !attendee.cancelled && !attendee.refunded &&
    !["cancelled", "refunded", "deleted"].includes(attendee.status)).map((attendee) => [attendee.id, attendee])).values()];
  const questions = new Map();
  const usedHeaders = new Set(BASE_HEADERS);
  active.forEach((attendee) => (attendee.answers || []).forEach((answer) => {
    const key = text(answer.question_id || answer.question);
    if (!key || questions.has(key)) return;
    const label = `Question: ${text(answer.question || answer.question_id)}`;
    let header = label;
    let suffix = 2;
    while (usedHeaders.has(header)) header = `${label} (${suffix++})`;
    usedHeaders.add(header);
    questions.set(key, header);
  }));
  const headers = [...BASE_HEADERS, ...questions.values()];
  const data = active.map((attendee) => {
    const profile = attendee.profile || {};
    const answers = new Map((attendee.answers || []).map((answer) => [text(answer.question_id || answer.question), text(answer.answer)]));
    const barcode = (attendee.barcodes || []).find((item) => item.barcode && item.status !== "voided");
    return [profile.first_name, profile.last_name,
      profile.name || [profile.first_name, profile.last_name].filter(Boolean).join(" "),
      profile.company, profile.job_title, profile.email, attendee.ticket_class_name,
      barcode?.barcode, attendee.id, ...[...questions.keys()].map((key) => answers.get(key))].map(text);
  });
  return { headers, data };
};
